<div class="flex flex-col flex-auto min-w-0 pageContainer">
    <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-12">
        <a role="tab" class="tab" (click)="toFieldSummary()"> Field Summary </a>
        <a role="tab" class="tab primary-tab-active"> String Summary </a>
    </div>

    <div class="flex flex-col w-full">
        <form [formGroup]="searchForm">
            <div class="flex justify-between gap-2 mb-4">
                <div class="flex justify-start gap-2">
                    <div class="w-20">
                        <mat-form-field class="w-full">
                            <mat-select formControlName="PageSize">
                                <mat-option [value]="5"> 5 </mat-option>
                                <mat-option [value]="10"> 10 </mat-option>
                                <mat-option [value]="20"> 20 </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <button
                        class="group btn btn-outline btn-default dt-download mx-2"
                        [matMenuTriggerFor]="downloadMenu"
                    >
                        <mat-icon
                            class="text-primary group-hover:text-white"
                            svgIcon="heroicons_solid:arrow-down-tray"
                        ></mat-icon>
                    </button>
                    <mat-menu #downloadMenu="matMenu">
                        <button
                            mat-menu-item
                            (click)="downloadStringsListExcel()"
                        >
                            Excel
                        </button>
                    </mat-menu>
                </div>
                <div class="flex justify-end gap-2">
                    <button
                        class="btn btn-outline btn-default"
                        (click)="reset()"
                    >
                        Reset
                    </button>
                    <button
                        class="group btn btn-outline btn-default hover:text-white"
                        (click)="fetchStringSummaryData()"
                    >
                        <mat-icon
                            class="text-primary group-hover:text-white"
                            svgIcon="heroicons_solid:arrow-path"
                        ></mat-icon>
                    </button>
                </div>
            </div>
        </form>

        <div
            class="w-full border border-gray-200 rounded-lg overflow-hidden relative bg-white"
        >
            <div class="grid overflow-x-auto">
                <!-- Header -->
                <div
                    class="table-string-summary-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                    matSort
                    matSortDisableClear
                >
                    <div class="border py-8 text-center">No</div>
                    <div
                        [mat-sort-header]="'fieldLongName'"
                        class="flex justify-center border py-4"
                    >
                        Field
                    </div>
                    <div
                        [mat-sort-header]="'platformLongName'"
                        class="flex justify-center border py-4"
                    >
                        Platform
                    </div>
                    <div
                        [mat-sort-header]="'wellLongName'"
                        class="flex justify-center border py-4"
                    >
                        Well
                    </div>
                    <div
                        [mat-sort-header]="'stringShortName'"
                        class="flex justify-center border py-4"
                    >
                        Well String
                    </div>
                    <div
                        [mat-sort-header]="'status'"
                        class="flex justify-center border py-4"
                    >
                        Status
                    </div>
                    <div
                        [mat-sort-header]="'result'"
                        class="flex justify-center border py-4"
                    >
                        Well Healthiness Status
                    </div>
                    <div
                        [mat-sort-header]="'riskRanking'"
                        class="flex justify-center border py-4"
                    >
                        Risk Ranking
                    </div>
                </div>

                <!-- Rows -->
                <ng-container *ngIf="dt.rows.length; else noRecords">
                    <ng-container
                        *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;"
                    >
                        <div
                            class="table-string-summary-grid grid items-center border-b"
                            [ngClass]="{'bg-primary-100': i % 2 }"
                        >
                            <div class="py-4 text-center">
                                {{ searchForm.get('Page')?.value ?
                                ((searchForm.get('Page')?.value - 1) *
                                dt.page.size) + i + 1 : i + 1 }}.
                            </div>
                            <div
                                class="flex truncate justify-center"
                                [title]="row.fieldLongName"
                            >
                                {{ row.fieldLongName }}
                            </div>
                            <div
                                class="flex truncate justify-center"
                                [title]="row.platformLongName"
                            >
                                {{ row.platformLongName }}
                            </div>
                            <div
                                class="flex truncate justify-center"
                                [title]="row.wellLongName"
                            >
                                {{ row.wellLongName }}
                            </div>
                            <div
                                class="flex truncate justify-center"
                                [title]="row.stringShortName"
                            >
                                {{ row.stringShortName }}
                            </div>
                            <div
                                class="flex truncate justify-center"
                                [title]="row.status"
                            >
                                {{ row.status }}
                            </div>
                            <div
                                class="flex truncate justify-center"
                                [title]="row.result"
                            >
                                {{ row.result }}
                            </div>
                            <div
                                class="flex truncate justify-center"
                                [title]="row.riskRanking"
                            >
                                {{ row.riskRanking }}
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #noRecords>
                    <div
                        *ngIf="!isLoading"
                        class="flex flex-col items-center justify-center p-12 w-full text-center"
                    >
                        <span class="text-gray-500 font-medium text-sm"
                            >No records found.</span
                        >
                    </div>
                </ng-template>
            </div>

            <!-- Loading Overlay -->
            <div
                *ngIf="isLoading"
                class="absolute inset-0 bg-white/60 z-10 flex items-center justify-center backdrop-blur-[1px]"
            >
                <mat-spinner diameter="40"></mat-spinner>
            </div>

            <div
                class="flex justify-between inset-x-0 bottom-0 border-t z-10 bg-gray-50 dark:bg-transparent"
            >
                <div class="content-center px-3">
                    {{ dt.page.totalRecords }} {{ dt.page.totalRecords <= 1 ?
                    'record' : 'records' }}
                </div>
                <!-- Prevent interaction slightly if loading in some cases, though spinner blocks most -->
                <mat-paginator
                    class="bg-gray-50"
                    [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page.totalRecords"
                    [pageSize]="dt.page.size"
                    [hidePageSize]="true"
                    [pageIndex]="(searchForm.get('Page')?.value || 1) - 1"
                    showFirstLastButtons
                ></mat-paginator>
            </div>
        </div>
    </div>
</div>
